import { render, staticRenderFns } from "./KeHuSiXiangMS.vue?vue&type=template&id=4a5a2912&scoped=true&"
import script from "./KeHuSiXiangMS.vue?vue&type=script&lang=js&"
export * from "./KeHuSiXiangMS.vue?vue&type=script&lang=js&"
import style0 from "./KeHuSiXiangMS.vue?vue&type=style&index=0&id=4a5a2912&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a2912",
  null
  
)

export default component.exports